import { useState } from "react";
import { useApp, api } from "../context";
import { Shell, Btn, TrustBar, EmptyState, TierBadge } from "../components";
import PostCard from "../PostCard";

const UserProfilePage = ({ vuData, setVuData, blockedUsers, setBlockedUsers, startConvo }) => {
  const { c, go, user, posts, flash, viewingUser, setViewingUser } = useApp();
  const [showUpgrade, setShowUpgrade] = useState(false);

  if (String(viewingUser) === String(user?.id)) { setViewingUser(null); go("profile"); return null; }

  const vuPosts = posts.filter(p => String(p.authorId) === String(viewingUser));

  if (!vuData) return (
    <Shell title="Loading..." showBack onBack={() => { setViewingUser(null); go("feed"); }}>
      <div style={{ padding: "40px 0", textAlign: "center" }}>
        <div style={{ fontSize: 32, marginBottom: 10 }}>⏳</div>
        <div style={{ fontSize: 14, color: c.sub }}>Loading profile...</div>
      </div>
    </Shell>
  );

  const vu = vuData;
  const isBlocked = vu.isBlocked;

  return (
    <Shell title={vu.name} showBack onBack={() => { setViewingUser(null); go("feed"); }}>
      <div style={{ padding: "16px 0" }}>
        <div style={{ background: c.card, borderRadius: 20, border: `1px solid ${c.border}`, overflow: "hidden", marginBottom: 14 }}>
          <div style={{ height: 80, background: `linear-gradient(135deg,${vu.color},${vu.color}88)` }} />
          <div style={{ padding: "12px 18px 18px", marginTop: -30 }}>
            <div style={{ width: 60, height: 60, borderRadius: 30, background: vu.avatarUrl ? `url(${vu.avatarUrl}) center/cover` : c.grad, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 28, border: `3px solid ${c.card}`, marginBottom: 10, overflow: "hidden" }}>{!vu.avatarUrl && vu.emoji}</div>
            <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 3 }}>
              <h2 style={{ fontSize: 18, fontWeight: 800, margin: 0, color: c.text }}>{vu.name}</h2>
              <TierBadge plan={vu.plan} verified={vu.verified} size={16} />
            </div>
            {vu.followsMe && !vu.isFollowing && <span style={{ fontSize: 10, fontWeight: 700, padding: "2px 8px", borderRadius: 6, background: c.priBg, color: c.pri, marginBottom: 4, display: "inline-block" }}>Follows you</span>}
<p style={{ fontSize: 13, color: c.sub, margin: "3px 0" }}>{vu.bio}</p>
            <div style={{ display: "flex", gap: 20, margin: "10px 0" }}>
              {[{ l: "Posts", v: vu.postCount }, { l: "Followers", v: vu.followers }, { l: "Following", v: vu.following }].map(s => (<div key={s.l} style={{ textAlign: "center" }}><div style={{ fontSize: 16, fontWeight: 800, color: c.text }}>{s.v}</div><div style={{ fontSize: 11, color: c.sub }}>{s.l}</div></div>))}
            </div>
            <div style={{ marginTop: 8 }}><TrustBar score={vu.trustScore} size="small" /></div>
            <div style={{ display: "flex", gap: 8, marginTop: 14 }}>
              <Btn primary full style={{ flex: 1 }} onClick={async () => {
                const res = await api(`/conversations/start`, { method: "POST", body: JSON.stringify({ user_id: viewingUser }) });
                if (res.ok && res.data?.conversation_id) {
                  startConvo(viewingUser);
                } else if (res.status === 403 || res.data?.message?.includes("Cannot message")) {
                  setShowUpgrade(true);
                } else {
                  startConvo(viewingUser);
                }
              }}>✉️ Message</Btn>
              <Btn full style={{ flex: 1, background: vu.isFollowing ? c.grnBg : "", color: vu.isFollowing ? c.grnTxt : "", whiteSpace: "nowrap" }} onClick={async () => {
                const res = await api(`/profile/${viewingUser}/follow`, { method: "POST" });
                if (res.ok) {
                  const following = res.data?.following ?? !vu.isFollowing;
                  setVuData(prev => ({ ...prev, isFollowing: following, followers: following ? (prev?.followers || 0) + 1 : (prev?.followers || 1) - 1 }));
                  flash(following ? "Following! 🎉" : "Unfollowed");
                } else if (res.data?.upgrade_required) {
                  setShowUpgrade(true);
                } else flash(res.message || "Failed", "error");
              }}>{vu.isFollowing ? "✓ Following" : vu.followsMe ? "Follow Back" : "Follow"}</Btn>
              {isBlocked ? (
                <Btn small onClick={async () => {
                  const res = await api(`/profile/${viewingUser}/block`, { method: "POST" });
                  if (res.ok) {
                    setVuData(prev => ({ ...prev, isBlocked: false }));
                    setBlockedUsers(prev => prev.filter(x => x !== viewingUser));
                    sessionStorage.removeItem("gc_viewing_user");
                    flash("Unblocked ✅");
                  } else flash("Failed to unblock", "error");
                }}>Unblock</Btn>
              ) : (
                <Btn danger small onClick={async () => {
                  const res = await api(`/profile/${viewingUser}/block`, { method: "POST" });
                  if (res.ok) {
                    setVuData(prev => ({ ...prev, isBlocked: true }));
                    setBlockedUsers(prev => [...prev, viewingUser]);
                    flash("User blocked", "error");
                  } else flash("Failed to block", "error");
                }}>Block</Btn>
              )}
            </div>
          </div>
        </div>
        <h4 style={{ fontSize: 14, fontWeight: 700, color: c.sub, marginBottom: 8 }}>Posts by {vu.name}</h4>
        {vuPosts.length === 0 ? <EmptyState icon="📝" title="No posts yet" /> : vuPosts.map(p => <PostCard key={p.id} post={p} />)}
      </div>
      {showUpgrade && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", backdropFilter: "blur(6px)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
          <div style={{ width: "100%", maxWidth: 340, background: c.card, borderRadius: 20, padding: "28px 24px", textAlign: "center", border: `1px solid ${c.border}` }}>
            <div style={{ fontSize: 44, marginBottom: 12 }}>🔒</div>
            <h3 style={{ fontSize: 17, fontWeight: 800, color: c.text, margin: "0 0 8px" }}>Upgrade Required</h3>
            <p style={{ fontSize: 13, color: c.sub, lineHeight: 1.5, margin: "0 0 20px" }}>This member is on a higher tier. Upgrade your plan to follow and connect with them.</p>
            <button onClick={() => { setShowUpgrade(false); go("premium"); }} style={{ width: "100%", padding: "13px 0", borderRadius: 12, border: "none", background: "linear-gradient(135deg, #6c5ce7, #7c6cff)", color: "#fff", fontSize: 15, fontWeight: 700, cursor: "pointer", marginBottom: 8 }}>Upgrade Now</button>
            <button onClick={() => setShowUpgrade(false)} style={{ width: "100%", padding: "11px 0", borderRadius: 12, border: `1px solid ${c.border}`, background: "transparent", color: c.sub, fontSize: 13, fontWeight: 600, cursor: "pointer" }}>Maybe Later</button>
          </div>
        </div>
      )}
    </Shell>
  );
};

export default UserProfilePage;
